import { Grid } from "@mui/material";
import AppBar from "./AppBar";
import CableDropdownPopup from "./pay-bills-dropdown/Cable";
import TelecomDropdownPopup from "./pay-bills-dropdown/Telecom";
import UtilitiesDropdownPopup from "./pay-bills-dropdown/Utilities";
import CustomDropdownPopup from "./pay-bills-dropdown/Custom";
import { usBanks } from "../../../data/us-banks";
import { useEffect, useState } from "react";


interface Props {
    billType: string;
    handleDropDownProviderOpen: ()=>void;
    dropdownOpt1: string;
    handleDropDownServiceProviderOpen: ()=>void;
    dropdownOpt2: string;

    dropdown: string;
    handleDropDownClose: ()=> void;
    setDropdownOpt1: React.Dispatch<React.SetStateAction<string>>;
    setDropdownOpt2: React.Dispatch<React.SetStateAction<string>>;
}
const BillsPaymentFrom: React.FC<Props>=({ 
    billType, 
    handleDropDownProviderOpen, 
    dropdownOpt1, 
    handleDropDownServiceProviderOpen,
    dropdownOpt2,
    dropdown,
    handleDropDownClose,
    setDropdownOpt1,
    setDropdownOpt2
})=>{

        const [selectBank, setSelectBank] = useState('')
        const [accountNumActive, setACcountNumActive] = useState(true)
        useEffect(()=>{
            if(selectBank != ''){
                setACcountNumActive(false)
            }else{
                setACcountNumActive(true)
            }
        }, [selectBank])
        
        
        
        const [btnActive2, setBtnActive2] = useState(true)
        const handleInputChange2 =(value: string) =>{
            if(value.length >= 10){
                setBtnActive2(false)
            }else{
                setBtnActive2(true)
            }
        }

    



    return (
        <>
            <main id="content" style={{display: 'block'}}>
                <AppBar />

                <section className="container">

                    <div style={{padding: '3rem 0'}}>
                        <Grid container style={{justifyContent: 'space-between', alignItems: 'center'}}>
                            <Grid item>
                                <h1 className="tranfer-title-text">Bills Payment</h1>
                                <p className="tranfer-lead-text">Pay bills on autopilot</p>
                            </Grid>
                            
                        </Grid>


                        <div className="custom-tabs" style={{marginTop: '3rem', width: '100%'}}>
                            <ul role="tablist">
                                <li role="tab"><span id="" className="active">Bills Payment</span></li>
                            </ul>
                        </div>

                        
                        {
                            billType === 'pay-bills-utilities'
                            ?
                                <div id="" className="groom-panel-2 active">
                                    <div className="groom-panel-header"><p>Utilities</p></div>

                                    <div style={{padding: '3rem 0'}}>

                                        <form className="transfer-form">

                                            <div className="transfer-form-row" style={{marginBottom: '1.6rem'}}>
                                                <div className="col-md-12" onClick={handleDropDownProviderOpen}>
                                                    <span className="select-beneficiary-button" role="button">{ dropdownOpt1 ? <strong>{dropdownOpt1}</strong> : 'Select Utility Type'}<img src="/imgs/nav-icons/sue2.svg" alt="" /></span>
                                                </div>
                                            </div>

                                            <div className="transfer-form-row" style={{marginBottom: '1.6rem'}}>
                                                <div className="col-md-12" onClick={handleDropDownServiceProviderOpen}>
                                                    <span className="select-beneficiary-button" role="button">{ dropdownOpt2 ? <strong>{dropdownOpt2}</strong> : 'Select Utility Provider'}<img src="/imgs/nav-icons/sue2.svg" alt="" /></span>
                                                </div>
                                            </div>


                                            <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                                <div className="transfer-form-row">
                                                    <div className="col-md-12">
                                                        <label>Customer ID</label>
                                                        <input name="recipientAccountNumber" type="text" className="form-control ft-recipient-input" placeholder="Enter Customer ID" autoCorrect="off"/>
                                                    </div>

                                                </div>
                                            </div>


                                            <div style={{marginTop: '0.6rem', width: '100%'}}>
                                                <button className="btn create-acc ft-submit-btn" disabled>Continue</button>
                                            </div>

                                        </form>

                                    </div>

                                </div>
                            :
                            billType === 'pay-bills-telecom'
                            ?
                                <div id="" className="groom-panel-2 active">
                                    <div className="groom-panel-header"><p>Telecom</p></div>

                                    <div style={{padding: '3rem 0'}}>

                                        <form className="transfer-form">

                                            <div className="transfer-form-row" style={{marginBottom: '1.6rem'}}>
                                                <div className="col-md-12" onClick={handleDropDownProviderOpen}>
                                                    <span className="select-beneficiary-button" role="button">{ dropdownOpt1 ? <strong>{dropdownOpt1}</strong> : 'Select Telecom Company'}<img src="/imgs/nav-icons/sue2.svg" alt="" /></span>
                                                </div>
                                            </div>



                                            <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                                <div className="transfer-form-row">
                                                    <div className="col-md-12">
                                                        <label>Account Number (Enter your account number from the telecom bill)</label>
                                                        <input name="recipientAccountNumber" type="text" className="form-control ft-recipient-input" placeholder="Enter Account Number" autoCorrect="off"/>
                                                    </div>

                                                </div>
                                            </div>


                                            <div style={{marginTop: '0.6rem', width: '100%'}}>
                                                <button className="btn create-acc ft-submit-btn" disabled>Continue</button>
                                            </div>

                                        </form>

                                    </div>

                                </div>
                            :
                            billType === 'pay-bills-cable-tv'
                            ?
                                <div id="" className="groom-panel-2 active">
                                    <div className="groom-panel-header"><p>Cable TV</p></div>

                                    <div style={{padding: '3rem 0'}}>

                                        <form className="transfer-form">

                                            <div className="transfer-form-row" style={{marginBottom: '1.6rem'}}>
                                                <div className="col-md-12" onClick={handleDropDownProviderOpen}>
                                                    <span className="select-beneficiary-button" role="button">{ dropdownOpt1 ? <strong>{dropdownOpt1}</strong> : 'Select Cable Provider'}<img src="/imgs/nav-icons/sue2.svg" alt="" /></span>
                                                </div>
                                            </div>



                                            <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                                <div className="transfer-form-row">
                                                    <div className="col-md-12">
                                                        <label>Account Number (Enter your account number from the cable bill)</label>
                                                        <input name="recipientAccountNumber" type="text" className="form-control ft-recipient-input" placeholder="Enter Account Number" autoCorrect="off"/>
                                                    </div>

                                                </div>
                                            </div>


                                            <div style={{marginTop: '0.6rem', width: '100%'}}>
                                                <button className="btn create-acc ft-submit-btn" disabled>Continue</button>
                                            </div>

                                        </form>

                                    </div>

                                </div>
                            :
                            billType === 'pay-bills-housing'
                            ?
                                <div className="ben-groom-panel">
                                    <div>
                                        <div style={{paddingTop: '3rem'}}></div>
                                        <div className="ben-groom-panel-inner">
                                            <div className="ben-groom-panel-inner-measure">
                                                

                                                <Grid container style={{justifyContent:'center', alignItems: 'center', padding: '3rem 0'}}>
                                                    <Grid xs={12} sm={7} item>
                                                        <div style={{textAlign: 'center', marginTop: '3rem'}}>
                                                            <svg width="100" height="4rem" viewBox="0 0 100 100" fill="none"><circle cx="50" cy="50" r="50" fill="#FAF5EB"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M36.4645 33.1311C37.4021 32.1934 38.6739 31.6667 40 31.6667H53.3333C53.7754 31.6667 54.1993 31.8423 54.5118 32.1548L64.5118 42.1548C64.8244 42.4674 65 42.8913 65 43.3333V63.3333C65 64.6594 64.4732 65.9312 63.5355 66.8689C62.5979 67.8065 61.3261 68.3333 60 68.3333H40C38.6739 68.3333 37.4021 67.8065 36.4645 66.8689C35.5268 65.9312 35 64.6594 35 63.3333V36.6667C35 35.3406 35.5268 34.0688 36.4645 33.1311ZM40 35C39.558 35 39.134 35.1756 38.8215 35.4882C38.5089 35.8007 38.3333 36.2246 38.3333 36.6667V63.3333C38.3333 63.7754 38.5089 64.1993 38.8215 64.5118C39.134 64.8244 39.558 65 40 65H60C60.442 65 60.8659 64.8244 61.1785 64.5118C61.4911 64.1993 61.6667 63.7754 61.6667 63.3333V44.0237L52.643 35H40Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M53.3333 31.6667C54.2538 31.6667 55 32.4129 55 33.3333V41.6667H63.3333C64.2538 41.6667 65 42.4129 65 43.3333C65 44.2538 64.2538 45 63.3333 45H53.3333C52.4129 45 51.6667 44.2538 51.6667 43.3333V33.3333C51.6667 32.4129 52.4129 31.6667 53.3333 31.6667Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6667 51.6667C41.6667 50.7462 42.4129 50 43.3333 50H56.6667C57.5871 50 58.3333 50.7462 58.3333 51.6667C58.3333 52.5871 57.5871 53.3333 56.6667 53.3333H43.3333C42.4129 53.3333 41.6667 52.5871 41.6667 51.6667Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6667 58.3333C41.6667 57.4129 42.4129 56.6667 43.3333 56.6667H56.6667C57.5871 56.6667 58.3333 57.4129 58.3333 58.3333C58.3333 59.2538 57.5871 60 56.6667 60H43.3333C42.4129 60 41.6667 59.2538 41.6667 58.3333Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6667 45C41.6667 44.0795 42.4129 43.3333 43.3333 43.3333H46.6667C47.5871 43.3333 48.3333 44.0795 48.3333 45C48.3333 45.9205 47.5871 46.6667 46.6667 46.6667H43.3333C42.4129 46.6667 41.6667 45.9205 41.6667 45Z" fill="#d1a23c"></path></svg>

                                                            <h5 className="bill-manage-form-heading">You currently have no active rent or mortgage plan. Kindly visit your local branch or call us to set up a plan</h5>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            :
                            billType === 'pay-bills-loan'
                            ?
                                <div className="ben-groom-panel">
                                    <div>
                                        <div style={{paddingTop: '3rem'}}></div>
                                        <div className="ben-groom-panel-inner">
                                            <div className="ben-groom-panel-inner-measure">
                                                

                                                <Grid container style={{justifyContent:'center', alignItems: 'center', padding: '3rem 0'}}>
                                                    <Grid xs={12} sm={7} item>
                                                        <div style={{textAlign: 'center', marginTop: '3rem'}}>
                                                            <svg width="100" height="4rem" viewBox="0 0 100 100" fill="none"><circle cx="50" cy="50" r="50" fill="#FAF5EB"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M36.4645 33.1311C37.4021 32.1934 38.6739 31.6667 40 31.6667H53.3333C53.7754 31.6667 54.1993 31.8423 54.5118 32.1548L64.5118 42.1548C64.8244 42.4674 65 42.8913 65 43.3333V63.3333C65 64.6594 64.4732 65.9312 63.5355 66.8689C62.5979 67.8065 61.3261 68.3333 60 68.3333H40C38.6739 68.3333 37.4021 67.8065 36.4645 66.8689C35.5268 65.9312 35 64.6594 35 63.3333V36.6667C35 35.3406 35.5268 34.0688 36.4645 33.1311ZM40 35C39.558 35 39.134 35.1756 38.8215 35.4882C38.5089 35.8007 38.3333 36.2246 38.3333 36.6667V63.3333C38.3333 63.7754 38.5089 64.1993 38.8215 64.5118C39.134 64.8244 39.558 65 40 65H60C60.442 65 60.8659 64.8244 61.1785 64.5118C61.4911 64.1993 61.6667 63.7754 61.6667 63.3333V44.0237L52.643 35H40Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M53.3333 31.6667C54.2538 31.6667 55 32.4129 55 33.3333V41.6667H63.3333C64.2538 41.6667 65 42.4129 65 43.3333C65 44.2538 64.2538 45 63.3333 45H53.3333C52.4129 45 51.6667 44.2538 51.6667 43.3333V33.3333C51.6667 32.4129 52.4129 31.6667 53.3333 31.6667Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6667 51.6667C41.6667 50.7462 42.4129 50 43.3333 50H56.6667C57.5871 50 58.3333 50.7462 58.3333 51.6667C58.3333 52.5871 57.5871 53.3333 56.6667 53.3333H43.3333C42.4129 53.3333 41.6667 52.5871 41.6667 51.6667Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6667 58.3333C41.6667 57.4129 42.4129 56.6667 43.3333 56.6667H56.6667C57.5871 56.6667 58.3333 57.4129 58.3333 58.3333C58.3333 59.2538 57.5871 60 56.6667 60H43.3333C42.4129 60 41.6667 59.2538 41.6667 58.3333Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6667 45C41.6667 44.0795 42.4129 43.3333 43.3333 43.3333H46.6667C47.5871 43.3333 48.3333 44.0795 48.3333 45C48.3333 45.9205 47.5871 46.6667 46.6667 46.6667H43.3333C42.4129 46.6667 41.6667 45.9205 41.6667 45Z" fill="#d1a23c"></path></svg>

                                                            <h5 className="bill-manage-form-heading">No active loan account</h5>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            :
                            billType === 'pay-bills-subscription'
                            ?
                                <div className="ben-groom-panel">
                                    <div>
                                        <div style={{paddingTop: '3rem'}}></div>
                                        <div className="ben-groom-panel-inner">
                                            <div className="ben-groom-panel-inner-measure">
                                                

                                                <Grid container style={{justifyContent:'center', alignItems: 'center', padding: '3rem 0'}}>
                                                    <Grid xs={12} sm={7} item>
                                                        <div style={{textAlign: 'center', marginTop: '3rem'}}>
                                                            <svg width="100" height="4rem" viewBox="0 0 100 100" fill="none"><circle cx="50" cy="50" r="50" fill="#FAF5EB"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M36.4645 33.1311C37.4021 32.1934 38.6739 31.6667 40 31.6667H53.3333C53.7754 31.6667 54.1993 31.8423 54.5118 32.1548L64.5118 42.1548C64.8244 42.4674 65 42.8913 65 43.3333V63.3333C65 64.6594 64.4732 65.9312 63.5355 66.8689C62.5979 67.8065 61.3261 68.3333 60 68.3333H40C38.6739 68.3333 37.4021 67.8065 36.4645 66.8689C35.5268 65.9312 35 64.6594 35 63.3333V36.6667C35 35.3406 35.5268 34.0688 36.4645 33.1311ZM40 35C39.558 35 39.134 35.1756 38.8215 35.4882C38.5089 35.8007 38.3333 36.2246 38.3333 36.6667V63.3333C38.3333 63.7754 38.5089 64.1993 38.8215 64.5118C39.134 64.8244 39.558 65 40 65H60C60.442 65 60.8659 64.8244 61.1785 64.5118C61.4911 64.1993 61.6667 63.7754 61.6667 63.3333V44.0237L52.643 35H40Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M53.3333 31.6667C54.2538 31.6667 55 32.4129 55 33.3333V41.6667H63.3333C64.2538 41.6667 65 42.4129 65 43.3333C65 44.2538 64.2538 45 63.3333 45H53.3333C52.4129 45 51.6667 44.2538 51.6667 43.3333V33.3333C51.6667 32.4129 52.4129 31.6667 53.3333 31.6667Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6667 51.6667C41.6667 50.7462 42.4129 50 43.3333 50H56.6667C57.5871 50 58.3333 50.7462 58.3333 51.6667C58.3333 52.5871 57.5871 53.3333 56.6667 53.3333H43.3333C42.4129 53.3333 41.6667 52.5871 41.6667 51.6667Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6667 58.3333C41.6667 57.4129 42.4129 56.6667 43.3333 56.6667H56.6667C57.5871 56.6667 58.3333 57.4129 58.3333 58.3333C58.3333 59.2538 57.5871 60 56.6667 60H43.3333C42.4129 60 41.6667 59.2538 41.6667 58.3333Z" fill="#d1a23c"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6667 45C41.6667 44.0795 42.4129 43.3333 43.3333 43.3333H46.6667C47.5871 43.3333 48.3333 44.0795 48.3333 45C48.3333 45.9205 47.5871 46.6667 46.6667 46.6667H43.3333C42.4129 46.6667 41.6667 45.9205 41.6667 45Z" fill="#d1a23c"></path></svg>

                                                            <h5 className="bill-manage-form-heading">There are no recurring payments associated with your account</h5>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            :
                            billType === 'pay-bills-custom'
                            ?
                                <div id="" className="groom-panel-2 active">
                                    <div className="groom-panel-header"><p>Schedule a Transaction</p></div>

                                    <div style={{padding: '3rem 0'}}>

                                        <form className="transfer-form">

                                            <div className="transfer-form-row" style={{marginBottom: '1.6rem'}}>
                                                <div className="col-md-12" onClick={handleDropDownProviderOpen}>
                                                    <span className="select-beneficiary-button" role="button">{ dropdownOpt1 ? <strong>{dropdownOpt1}</strong> : 'Add Payee'}<img src="/imgs/nav-icons/sue2.svg" alt="" /></span>
                                                </div>
                                            </div>

                                            <div className="transfer-form-row" style={{marginBottom: '1.6rem'}}>
                                                <div className="col-md-12" onClick={handleDropDownServiceProviderOpen}>
                                                    <span className="select-beneficiary-button" role="button">{ dropdownOpt2 ? <strong>{dropdownOpt2}</strong> : 'Payment Options'}<img src="/imgs/nav-icons/sue2.svg" alt="" /></span>
                                                </div>
                                            </div>



                                            <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                                <div className="transfer-form-row">
                                                    <div className="col-md-12">
                                                        <label>Payee Name (Enter the name of the person or business)</label>
                                                        <input name="recipientAccountNumber" type="text" className="form-control ft-recipient-input" placeholder="e.g. John Doe or Greenfield Supplies Ltd." autoCorrect="off"/>
                                                    </div>

                                                </div>
                                            </div>



                                            <div style={{marginTop: '0.6rem', width: '100%'}}>
                                                <button className="btn create-acc ft-submit-btn" disabled>Continue</button>
                                            </div>

                                        </form>

                                    </div>
                                    
                                </div>
                            :                          
                            null
                        }


            
                    </div>


                </section>

            </main>


                <UtilitiesDropdownPopup 
                    dropdown={dropdown} 
                    handleDropDownClose={handleDropDownClose} 
                    setDropdownOpt1={setDropdownOpt1}
                    dropdownOpt1={dropdownOpt1}
                    setDropdownOpt2={setDropdownOpt2}
                />
                <TelecomDropdownPopup
                    dropdown={dropdown} 
                    handleDropDownClose={handleDropDownClose} 
                    setDropdownOpt1={setDropdownOpt1}
                    dropdownOpt1={dropdownOpt1}
                    setDropdownOpt2={setDropdownOpt2}                
                />
                <CableDropdownPopup
                    dropdown={dropdown} 
                    handleDropDownClose={handleDropDownClose} 
                    setDropdownOpt1={setDropdownOpt1}
                    dropdownOpt1={dropdownOpt1}
                    setDropdownOpt2={setDropdownOpt2}                
                />
                <CustomDropdownPopup
                    dropdown={dropdown} 
                    handleDropDownClose={handleDropDownClose} 
                    setDropdownOpt1={setDropdownOpt1}
                    dropdownOpt1={dropdownOpt1}
                    setDropdownOpt2={setDropdownOpt2}  
                />
        </>
        
    )
};

export default BillsPaymentFrom;